import { SubscriptionResponse, SubscriptionRequest, OmitResponse } from "./types";
import { BASE_URL } from '../../config';
import { getApiKey, getFlywireCode, uuidv4 } from "services/common";
import * as Sentry from '@sentry/react';

export const createSubscription = async (
  subscriptionData: SubscriptionRequest,
  sessionToken: string,
  country: string,
  region: string,
  provider: string = 'FLY'
  ): Promise<SubscriptionResponse> => {
  const { token, ...cardlessData } = subscriptionData.card || {};
  const requestForSentry:any = {
    ...subscriptionData,
    card: cardlessData
  }
  try {
    const response = await fetch(`${BASE_URL}/api-payments/v1/subscriptions/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': getApiKey(region),
        'X-Session-Token': sessionToken,
        'X-User': 'web',
        'X-Recipient-ID': getFlywireCode(country, region),
        'X-Request-ID': uuidv4(),
        'X-Payment-Gateway': provider
      },
      body: JSON.stringify(subscriptionData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      Sentry.logger.error('subscriptionService[createSubscription] error', { session: sessionToken, request: requestForSentry, status: response.status, message: await response.text() });
      return {
        success: false,
        error: {
          message: `Failed to create subscription: ${response.statusText}`,
          code: `${response.status}`,
          status: response.status,
          details: errorData,
        }
      };
    }
    const data = await response.json();
    Sentry.logger.info('subscriptionService[createSubscription]', { session: sessionToken, request: {requestForSentry}, response: data });
    return {
      success: true,
      data
    };
  } catch (error) {
    Sentry.logger.error('subscriptionService[createSubscription] error', { session: sessionToken, request: requestForSentry, error });
    return {
      success: false,
      error: {
        message: `Unexpected error: ${error}`,
        code: 'NETWORK_ERROR'
      }
    };
  }
};

export const omit = async (
  sessionToken: string,
  applicationId: string,
  quotationId: string,
  country: string,
  region: string,
  provider: string = 'FLY'
  ): Promise<OmitResponse> => {
    try {
      const response = await fetch(`${BASE_URL}/api-payments/v1/subscriptions/omit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': getApiKey(region),
          'X-Session-Token': sessionToken,
          'X-User': 'web',
          'X-Recipient-ID': getFlywireCode(country, region),
          'X-Request-ID': uuidv4(),
          'X-Payment-Gateway': provider
        },
        body: JSON.stringify({
          "id_application": applicationId,
          "id_quotation": quotationId
        })
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        Sentry.logger.error('subscriptionService[omit] error', { session: sessionToken, request: { applicationId, quotationId }, status: response.status, message: await response.text() });
        return {
          success: false,
          error: {
            message: `Failed to create subscription: ${response.statusText}`,
            code: `${response.status}`,
            status: response.status,
            details: errorData,
          }
        };
      }
  
      const data = await response.json();
      Sentry.logger.info('subscriptionService[omit]', { session: sessionToken, request: { applicationId, quotationId }, response: data });
      return {
        success: true,
        data
      };
    } catch (error) {
      Sentry.logger.error('subscriptionService[omit] error', { session: sessionToken, request: { applicationId, quotationId }, error });
      return {
        success: false,
        error: {
          message: `Unexpected error: ${error}`,
          code: 'NETWORK_ERROR'
        }
      };
    }
  };